import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AgeEstimationHowItWorks.css';
import {
  ArrowForwardRounded,
  InfoOutlined,
  LockOutlined,
  ShieldOutlined,
  TimerOutlined
} from '@mui/icons-material';
import {
  BackButton,
  EnterpriseButton,
  EnterpriseCard,
  EnterpriseGrid,
  EnterpriseHero,
  EnterpriseShell,
  EnterpriseTopBar
} from './ui/EnterpriseLayout';

function AgeEstimationHowItWorks() {
  const navigate = useNavigate();

  return (
    <EnterpriseShell>
      <EnterpriseTopBar
        right={
          <>
            <BackButton onClick={() => navigate(-1)} />
            <span className="vt-chip vt-chip--subtle">Age estimation</span>
          </>
        }
      />

      <EnterpriseHero
        title="How age estimation works"
        subtitle="Take a quick camera scan. We don't reveal an exact age, only whether you meet the required threshold."
      />

      <EnterpriseGrid columns={1}>
        <EnterpriseCard>
          <ul className="vt-list">
            <li className="vt-listItem">
              <TimerOutlined className="vt-listIcon" />
              <span>Typically completes in seconds</span>
            </li>
            <li className="vt-listItem">
              <ShieldOutlined className="vt-listIcon" />
              <span>No one sees, stores, or shares your image</span>
            </li>
            <li className="vt-listItem">
              <LockOutlined className="vt-listIcon" />
              <span>Secure processing with short-lived data</span>
            </li>
            <li className="vt-listItem">
              <InfoOutlined className="vt-listIcon" />
              <span>We confirm pass/fail for the required age — not an exact estimate</span>
            </li>
          </ul>

          <p className="vt-note">
            Powered by Veritage.
          </p>

          <div className="vt-actions">
            <EnterpriseButton variant="primary" onClick={() => navigate('/age-estimation/consent')}>
              <span>Continue</span>
              <ArrowForwardRounded className="vt-btnIcon" />
            </EnterpriseButton>
            <EnterpriseButton variant="secondary" onClick={() => navigate('/')}>
              <span>Back to options</span>
            </EnterpriseButton>
          </div>
        </EnterpriseCard>
      </EnterpriseGrid>
    </EnterpriseShell>
  );
}

export default AgeEstimationHowItWorks;
